<template>
  <div>
    <div style="margin: 0; position: relative">
      <div
        v-if="isLoading"
        style="
          position: fixed;
          top: 0;
          left: 0;
          width: 100vw;
          height: 100vh;
          background: rgba(255, 255, 255, 0.6);
          z-index: 9999;
          display: flex;
          justify-content: center;
          align-items: center;
          flex-direction: column;
        "
      >
        <div style="margin-bottom: 1rem; font-size: 1.2rem">Loading...</div>
        <div class="loader-circle"></div>
      </div>

      <div style="margin: 0">
        <vs-card style="padding: 0 !important; margin: 0 !important">
         <vs-row style="background: linear-gradient(118deg, rgba(var(--vs-primary),1), rgba(var(--vs-primary),0.7));
              padding: 10px 12px !important;
              margin: 0 important;
              display: flex;
              align-items: center; ">
            <vs-col class="w-1/2">
              <h4 style="margin-left: 14%; color: white; padding: 0">
                OP Ticket
              </h4>
            </vs-col>
            <vs-col class="w-1/2">
              <div style="margin-left: 90%; cursor: pointer">
                <feather-icon
                  icon="XIcon"
                  style="color: white"
                  class="custom-class"
                  title="close"
                  @click="exit"
                ></feather-icon>
              </div>
            </vs-col>
          </vs-row>
          <vs-divider style="margin-top: 0"></vs-divider>

          <div style="padding-left: 4%; padding-right: 4%">
            <vs-row>
              <vs-alert
                color="danger"
                icon-pack="feather"
                icon="icon-info"
                v-for="(errors, err) in errorMessage"
                v-bind:key="err"
              >
                <span>{{ errors }}</span>
              </vs-alert>
              <vs-alert
                color="danger"
                icon-pack="feather"
                icon="icon-info"
                v-for="error in errors.all()"
                v-bind:key="error"
              >
                <span>{{ error }}</span>
              </vs-alert>
            </vs-row>

            <vs-row style="margin-left: 2%">
              <!-- Left Column (Patient Details) -->
              <vs-col vs-lg="6" vs-sm="12" class="pl-4 pr-2">
                <vs-row class="mb-3" style="margin-top: 2%">
                  <vs-col>
                    <vs-row class="mb-1">
                      <vs-col vs-lg="3" class="topPad">
                        <span class="inputStyles">OP No</span>
                      </vs-col>
                      <vs-col vs-lg="3" vs-md="6" vs-sm="12">
                        <vs-input
                          style=""
                          class="responsive-opno"
                          readonly
                          name="opNo"
                          v-model="opTicketData.opId"
                        />
                      </vs-col>
                      <vs-col
                        vs-lg="1"
                        vs-md="2"
                        vs-sm="2"
                        class="p-0"
                        style="display: flex; align-items: center"
                      >
                        <div v-if="iconSearch" title="Search">
                          <SearchIcon
                            title="Search"
                            style="
                              margin-top: 5px;
                              cursor: pointer;
                              width: 20px;
                              height: 20px;
                            "
                            @click="goToOpDashboard"
                          />
                        </div>
                      </vs-col>
                      <vs-col
                        vs-lg="1"
                        vs-md="2"
                        vs-sm="2"
                        class="p-0"
                        style="
                          display: flex;
                          align-items: center;
                          margin-left: -15px;
                        "
                      >
                        <div v-if="showRefreshIcon" title="Clear">
                          <RefreshCwIcon
                            style="
                              margin-top: 5px;
                              cursor: pointer;
                              width: 18px;
                              height: 18px;
                            "
                            @click="clearOpTicket"
                            title="Clear All Fields"
                          />
                        </div>
                      </vs-col>
                    </vs-row>
                  </vs-col>
                </vs-row>
                <div style="margin-top: 3%">
                  <patient-details
                    :patientId="patientId"
                    :patientDetails="patientDetails"
                    :billData="BillData"
                    :opData="opTicketData"
                    :iconShow="iconShow"
                    :showAddIcon="showAddIcon"
                    :showSearchIcon="showSearchIcon"
                    class="patient-details"
                    @fetchPatient="onFetchPatient"
                      sourceType="op"
                  />
                </div>
              </vs-col>

              <!-- Right Column (Appointment Details) -->

              <vs-col vs-lg="6" vs-sm="12" class="pl-2">
                <!-- Added padding -->
                <vs-row class="mb-3" style="margin-top: 2%">
                  <vs-col vs-lg="3" class="topPad">
                    <span class="inputStyles">OP Date</span>
                  </vs-col>
                  <vs-col vs-lg="4" vs-sm="6">
                    <vs-input
                      readonly
                      name="OpDate"
                      v-model="displayOpDate"
                      v-validate="'required'"
                      style="width: 230px"
                    />
                  </vs-col>
                </vs-row>

                <div style="margin-top: 4%">
                  <vs-row class="mb-1">
                    <vs-col vs-lg="3" class="topPad">
                      <span class="inputStyles">Doctor Name *</span>
                    </vs-col>
                    <vs-col vs-lg="4" vs-sm="6">
                      <select
                        v-model="opTicketData.doctorId"
                        class="vs-select--input myselect"
                        v-validate="'required'"
                        style="width: 230px"
                        name="Doctor"
                        @change="doctorOnChange(opTicketData.doctorId)"
                        :disabled="readonlyFlag"
                      >
                        <option
                          v-for="(item, index) in doctorList"
                          v-bind:key="index"
                          :value="item.id"
                        >
                          {{ item.name }}
                        </option>
                      </select>
                    </vs-col>
                  </vs-row>
                </div>
                <!--vs-row class="mb-1" style="margin-top: 1%;">
    <vs-col vs-lg="3" class="topPad">
      <span class="inputStyles">AppointmentDetails</span>
    </vs-col>
    <vs-col vs-lg="2" vs-sm="3" style="padding-right: 5px;">
      <vs-input type="date" :readonly="readonlyFlag" 
      
                v-model="opTicketData.appointmentDate" 
                 @change="onAppointmentDateChange"
                style="width:114px; margin-right:15px;" />
    </vs-col>
    <vs-col vs-lg="2" vs-sm="3" style="padding-left: 5px;">
      <vs-input type="time" :readonly="readonlyFlag" 
                v-model="opTicketData.appointmentTime" 
                style="width:114px; margin-left:15px;" />
    </vs-col>
     <vs-col vs-lg="1" class="p-0" style="display:flex; align-items:center; margin-left: 30px;">
    <SearchIcon
      title="Search schedule"
      style="cursor:pointer; width:20px; height:20px;"
      @click="searchSchedule"
      :class="{ 'disabled-icon': !opTicketData.doctorId || !opTicketData.appointmentDate }"
    ></SearchIcon>
  </vs-col>
  </vs-row>-->
                <vs-row
                  class="mb-1"
                  style="margin-top: 1%; align-items: center"
                >
                  <!-- Label -->
                  <vs-col vs-lg="3" class="topPad">
                    <span class="inputStyles">Appointment Details</span>
                  </vs-col>

                  <vs-col vs-lg="6" vs-sm="9">
                    <div
                      style="
                        display: flex;
                        align-items: center;
                        gap: 10px;
                        flex-wrap: nowrap;
                      "
                    >
                      <!-- Fixed-width input group -->
                      <div style="display: flex; gap: 8px; width: 230px">
                        <flat-pickr
                          :readonly="readonlyFlag"
                          v-model="appointmentDateDisplay"
                          @change="onAppointmentDateChange"
                          :config="{ dateFormat: 'd/m/Y' }"
                          style="flex: 1; min-width: 100px"
                        />
                        <flat-pickr
                          :readonly="readonlyFlag"
                          v-model="appointmentTimeDisplay"
                          :config="{
                            enableTime: true,
                            noCalendar: true,
                            time_24hr: false,
                            dateFormat: 'h:i K',
                          }"
                          style="flex: 1; min-width: 100px"
                          class="time-picker"
                        />
                      </div>

                      <SearchIcon
                        title="Search schedule"
                        style="cursor: pointer; width: 20px; height: 20px"
                        @click="searchSchedule"
                        :class="{
                          'disabled-icon':
                            !opTicketData.doctorId ||
                            !opTicketData.appointmentDate,
                        }"
                      />
                    </div>
                  </vs-col>
                </vs-row>

                <vs-row class="mb-1" style="margin-top: 1%">
                  <vs-col vs-lg="3" class="topPad">
                    <span class="inputStyles">Token No</span>
                  </vs-col>
                  <vs-col vs-lg="4" vs-sm="6">
                    <vs-input
                      style="width: 230px"
                      type="text"
                      :readonly="readonlyFlag"
                      v-model="opTicketData.tokenNo"
                    />
                  </vs-col>
                </vs-row>

                <vs-row class="mb-1" style="margin-top: 1%">
                  <vs-col vs-lg="3" class="topPad">
                    <span class="inputStyles">Note</span>
                  </vs-col>
                  <vs-col vs-lg="4" vs-sm="6">
                    <vs-textarea
                      style="width: 230px; min-height: 70px"
                      v-model="opTicketData.note"
                      :readonly="readonlyFlag"
                    />
                  </vs-col>
                </vs-row>
              </vs-col>
            </vs-row>

            <!--  billing sextion -->

            <vs-row class="topPad">
              <vs-col vs-lg="11">
                <billing-table
                  ref="billing"
                  :patientId="patientId"
                  :BillData="BillData"
                  :billingType="['clinic']"
                  :readonlyFlag="readonlyFlag"
                  :doctorId="opTicketData.doctorId"
                  style="
                    padding-left: 4%;
                    padding-right: 9%;
                    padding-bottom: 10%;
                  "
                  @rows-updated="recalculateSlNo"
                ></billing-table>
              </vs-col>
              <vs-col vs-lg="1"> </vs-col>
            </vs-row>

            <!--  billing sextion -->
          </div>
        </vs-card>

        <vs-row justify="center">
          <vs-col vs-lg="10">
            <vs-card class="footer" style="padding: 10px">
              <div
                class="btn-group"
                style="
                  display: flex;
                  justify-content: flex-end;
                  gap: 5px;
                  padding-right: 0;
                  margin-right: 290px;
                  flex-wrap: wrap;
                "
              >
                <vs-button
                  style="width: 100px"
                  :disabled="saveFlag"
                  @click="validateOp"
                  type="gradient"
                  >Save</vs-button
                >
                <vs-button
                  style="width: 100px"
                  :disabled="printFlag"
                  @click="printOp"
                  color="warning"
                  type="gradient"
                  >Print OP</vs-button
                >
                <vs-button
                  style="width: 100px"
                  :disabled="printFlag"
                  @click="printBill"
                  color="success"
                  type="gradient"
                  >Print Bill</vs-button
                >
                <vs-button
                  style="width: 100px"
                  v-if="opTicketData.opId !== 'New'"
                  :disabled="printFlag"
                  color="danger"
                  @click="confirmCancelOp"
                  type="gradient"
                  >Cancel</vs-button
                >
                <vs-button
                  style="width: 100px"
                  @click="exit"
                  color="danger"
                  type="gradient"
                  >Exit</vs-button
                >
              </div>
            </vs-card>
          </vs-col>
        </vs-row>

        <print-bill
       v-show="showBill"
            ref="printBill"
          style="display: none"
          :patientId="patientId"
          :billPrintData="BillData"
          :doctorName="opTicketData.doctorName"
          :patientDetails="patientDetails"
        ></print-bill>
        <print-op
          v-show="showOp"
          ref="printOpTicket"
          :patientId="patientId"
          :opPrintData="opTicketData"
          :patientDetails="patientDetails"
        ></print-op>
      </div>
    </div>
    <vs-popup
      :active.sync="showSchedule"
      title="Available Tokens"
      class="holamundo"
    >
      <div class="tokenbox" style="max-height: 300px; overflow: auto">
        <table class="token-table" style="width: 100%">
          <thead>
            <tr>
              <th>Time</th>
              <th>Token No</th>
              <th>Status</th>
            </tr>
          </thead>
          <tbody>
            <tr
              v-for="slot in availableTokens"
              :key="slot.timeSlotId"
              :class="{ selected: slot.timeSlotId === selectedSlotId }"
              @dblclick="fillToken(slot)"
            >
              <td>{{ slot.tokenTime }}</td>
              <td>{{ slot.availableTokenNo }}</td>
              <td :class="slot.bookingFlag === 'Y' ? 'booked' : 'available'">
                {{ slot.bookingFlag === "Y" ? "Booked" : "Available" }}
              </td>
            </tr>
          </tbody>
        </table>

        <div
          v-if="!availableTokens.length"
          style="text-align: center; margin-top: 10px"
        >
          No tokens available for this date.
        </div>
      </div>
    </vs-popup>
  </div>
</template>



<script>
import { SearchIcon, RefreshCwIcon } from 'vue-feather-icons';

import FlatPickr from 'vue-flatpickr-component';
import 'flatpickr/dist/flatpickr.css';
import BillingTable from '../components/BillingTable.vue';
import PatientDetails from '../components/PatientDetails.vue';
import PrintOp from '../components/PrintOp';
import PrintBill from '../components/PrintBill.vue';

export default {
    data() {
        return {
              showSchedule: false,          
              availableTokens: [],         
              isLoadingSchedule: false,    
              selectedSlotId: null ,
              iconSearch:true,
              showRefreshIcon:true,
              opTicketData: {
                "opId": "New",
                "opDate": new Date().toISOString().slice(0, 10),
                "doctorId": null,
                "doctorName": "",
                "bookingPhoneNo": "",
                "appointmentDate": new Date().toISOString().slice(0, 10),
                "appointmentTime": "",
                "tokenBookingId": "",
                "note": "",
                "tokenNo": "",
                "doctorDegree": "",
                 "patientName": "",
                "patientAge": "",
                "gender": "",
                "phoneNo": "",
                "place": "",
                "shiftId":"",
                "timeSlotId":"",
            },
            BillData: {
                billItems: [{
                    "slNo": 1,
                    "billItemId": 0,
                    "billItem": "",
                    "qty": "",
                    "rate": "",
                    "amount": "",
                    "taxId": 0,
                    "taxAmount": "",
                    "gstValue": ""
                }],
                paymentModeId: 1,
                paymentMode: "Cash",
                subTotal: "",
                receiptAmount: "",
                balanceAmount: "",
                totalAmount: "",
                discount: "0.00",
                discountType: "V",
                refId: "",
                billType: "1",
                note: "",
                billId: "New",
                billDate: new Date().toISOString().slice(0, 10),
                attachedFlag: "Y",
                
            },
            patientId: "",
            doctorList: [{
                id: 0,
                name: "Select"
            }],
            errorMessage: [],
            readonlyFlag: false,
            saveFlag: false,
            doctorFlag: false,
            printFlag: false,
            doctorName: "",
            patientDetails: {},
           // iconShow: true,
            showAddIcon:true,
            showSearchIcon:true,
            defaultDoctorCharges: [],
              isLoading: true,
          
            showOp: false,
            showBill:false,

        }
        
    },
    components: {
        BillingTable,
        PatientDetails,
        PrintBill,
        PrintOp,
        SearchIcon,
        RefreshCwIcon,
          FlatPickr,

    },
   async mounted() {
  
          this.isLoading = true
          try{
         await this.getDoctorList();
        if (this.$store.state.opData) {
            this.patientId = this.$store.state.patientId;
            this.opTicketData=this.$store.state.opData.opData;
            this.BillData=this.$store.state.opData.billData;
           // console.log("billdata---",this.BillData)
            this.$store.dispatch('updateOpData', '');
            this.$store.dispatch('updatePatientId', '');

             if (this.patientId ) {
     await this.getpatientDetails();
    }

    this.showAddIcon = !this.$route.query.opId;
 // this.showRefreshIcon = !this.$route.query.opId;
  this.showSearchIcon = true;
  } else if (this.$route.query.patientId) {
    this.patientId = parseInt(this.$route.query.patientId);
   // this.iconShow = false;
   this.showAddIcon=false;
  this.showSearchIcon = true;
    this.showRefreshIcon =true;
   

    
    if (!this.$route.query.opId) {
      await this.getpatientDetails();
    }
  } else {
    this.patientId = '';
    //this.iconShow = true;
    this.showAddIcon=true;
    this.showSearchIcon=true;
    this.showRefreshIcon = true;
  }

  if (this.$route.query.opId) {
    this.opTicketData.opId = parseInt(this.$route.query.opId);
    //this.iconShow = false;
     this.showSearchIcon=true;
    await this.getOpDetails();
  }
  if (this.$route.query.tokenId) {
  this.opTicketData.tokenBookingId = parseInt(this.$route.query.tokenId);
  await this.getTokenDetails();
  this.doctorFlag = true;
        }
          }
           catch (error) {
    console.error("Error during mounted init:", error);
  } finally {
    this.isLoading = false; 
  }
        
    },
    computed: {
  displayOpDate: {
    get() {
      if (!this.opTicketData.opDate) return '';
      const [year, month, day] = this.opTicketData.opDate.split('-');
      return `${day}/${month}/${year}`;
    },
    set(value) {
      const [day, month, year] = value.split('/');
      this.opTicketData.opDate = `${year}-${month}-${day}`;
    }
  },
  appointmentDateDisplay: {
    get() {
      if (!this.opTicketData.appointmentDate) return '';
      const [year, month, day] = this.opTicketData.appointmentDate.split('-');
      return `${day}/${month}/${year}`;   // display to user
    },
    set(value) {
      const [day, month, year] = value.split('/');
      this.opTicketData.appointmentDate = `${year}-${month}-${day}`; 
    }
  },
  appointmentTimeDisplay: {
    get() {
      if (!this.opTicketData.appointmentTime) return '';
      const [hours, minutes] = this.opTicketData.appointmentTime.split(':').map(Number);
      const date = new Date();
      date.setHours(hours);
      date.setMinutes(minutes);
      return date.toLocaleTimeString([], { hour: '2-digit', minute: '2-digit', hour12: true }); // show 12-hour AM/PM
    },
    set(value) {
      if (!value) return;
      // Convert "2:00 PM" → "14:00"
      const date = new Date(`1970-01-01 ${value}`);
      const hours = String(date.getHours()).padStart(2, '0');
      const minutes = String(date.getMinutes()).padStart(2, '0');
      this.opTicketData.appointmentTime = `${hours}:${minutes}`; // save 24-hour
    }
  }
},

    methods: {

    clearOpTicket() {
  this.patientId = '';
  this.patientDetails = {};
  
  this.opTicketData = {
    opId: "New",
    opDate: new Date().toISOString().slice(0, 10),
    doctorId: null,
    doctorName: "",
    bookingPhoneNo: "",
    appointmentDate: new Date().toISOString().slice(0, 10),
    appointmentTime: "",
    tokenBookingId: "",
    note: "",
    tokenNo: "",
    doctorQualification: "",
    patientName: "",
    patientAge: "",
    gender: "",
    phoneNo: "",
    place: ""
  };

  this.BillData = {
    billItems: [{
      slNo: 1,
      billItemId: 0,
      billItem: "",
      qty: "",
      rate: "",
      amount: "",
      taxId: 0,
      taxAmount: "",
      gstValue: ""
    }],
    paymentModeId: 1,
    paymentMode: "Cash",
    subTotal: "",
    receiptAmount: "",
    balanceAmount: "",
    totalAmount: "",
    discount: "0.00",
    discountType: "V",
    refId: "",
    billType: "1",
    note: "",
    billId: "New",
    billDate: new Date().toISOString().slice(0, 10),
    attachedFlag: "Y",
    
  };
 this.$router.replace({ query: {} });
  this.showAddIcon=true;
  this.readonlyFlag = false;
  this.saveFlag = false;
  this.printFlag = false;

  this.errorMessage = [];

if (this.$validator && typeof this.$validator.reset === 'function') {
  this.$validator.reset(); 
}


  this.$vs.notify({
    title: 'Cleared',
    text: 'OP Ticket form has been cleared.',
    color: 'success',
    position: 'top-right'
  });
},

        goToOpDashboard() {
                this.$router.push({ name: 'OP' });
        //console.log("goToOpDashboard clicked - function not implemented yet.");
    },
    onFetchPatient(patientId) {
         console.log(" Received fetchPatient event with:", patientId);
    this.patientId = patientId;          // update parent patientId
    this.getpatientDetails();            // fetch patient details
},
     
   
  convertTo24Hour(time12h) {
  if (!time12h) return "";
  const [time, modifier] = time12h.split(" ");
  let [hours, minutes] = time.split(":").map(Number);

  if (modifier === "PM" && hours !== 12) hours += 12;
  if (modifier === "AM" && hours === 12) hours = 0;

  return `${hours.toString().padStart(2, "0")}:${minutes.toString().padStart(2, "0")}`;
},
       async getpatientDetails() {
          try{
            
            var request = {
                companyId: this.$session.get('companyId'),
                regNo: this.patientId
            };
             const response=await this.$http.post(
                    "getpatiententry",
                    JSON.stringify(request), {
                        headers: {
                            "Content-Type": "application/json"
                        }
                    })
                
                
                    if (response.data && response.data.data) {
                this.patientDetails = response.data.data;
                 this.errorMessage = [];
            
            } else {
                this.patientDetails = {};
                this.$vs.notify({
                    title: 'Patient Not Found',
                    text: `No patient found with ID ${this.patientId}.`,
                    color: 'warning',
                    position: 'top-right'
                });
            }



                } catch(error) {
        console.error("Error fetching patient details:", error);
        this.patientDetails = {};
        this.$vs.notify({
            title: 'Error',
            text: 'Failed to fetch patient details. Please try again.',
            color: 'danger',
            position: 'top-right'
        });
    };
      },
        exit() {
            if (this.$route.query.tokenId && this.saveFlag == true) {
                this.$router.push({
                    path: 'patientTray',
                    query: {
                        patientId: this.patientId
                    }
                })
            } else if ( this.$store.state.opFlag == true) {
                this.$router.push({
                    path: 'OpDashboardView',
                })
            } else {
                this.$router.go(-1);
            }
        },
        async searchSchedule() {
  if (!this.opTicketData.doctorId || !this.opTicketData.appointmentDate) {
    this.$vs.notify({ title: 'Select doctor and date', color: 'warning' });
    return;
  }
  this.isLoadingSchedule = true;
  try {
    const req = {
      companyId: this.$session.get('companyId'),
      doctorId: this.opTicketData.doctorId,
      availableDate: this.opTicketData.appointmentDate
    };
    const resp = await this.$http.post("getalldoctorschedules", JSON.stringify(req), { headers: { "Content-Type": "application/json" }});
    const result = resp.data.data || [];

    // flatten
    this.availableTokens = [];
    result.forEach(shift => {
      shift.tokenDetails.forEach(token => {
        this.availableTokens.push({
          timeSlotId: token.timeSlotId,
          tokenTime: token.tokenTime,
          availableTokenNo: token.availableTokenNo,
          bookingFlag: token.bookingFlag,     // 'Y' or 'N'
          shiftName: shift.shiftName,
          shiftId: shift.shiftId
        });
      });
    });

    this.showSchedule = true;
    if (this.availableTokens.length === 0) {
      this.$vs.notify({ title: 'No schedule for selected date', color: 'warning' });
    }
  } catch (err) {
    console.error(err);
    this.$vs.notify({ title: 'Failed to load schedule', color: 'danger' });
  } finally {
    this.isLoadingSchedule = false;
  }
},
fillToken(slot) {
if (slot.bookingFlag === 'N') { 
    this.selectedSlotId = slot.timeSlotId;

    
    this.opTicketData.tokenNo = slot.availableTokenNo;
    this.opTicketData.appointmentTime =  this.convertTo24Hour(slot.tokenTime);
  this.opTicketData.shiftId=slot.shiftId;
  this.opTicketData.timeSlotId=slot.timeSlotId;
     setTimeout(() => {
        this.showSchedule = false;
    }, 300);
     } else {
        
        this.$vs.notify({
            title: 'Token Booked',
            text: 'This token is already booked. Please select an available token.',
            color: 'warning',
            position: 'top-right'
        });
    }
  },

       async getTokenDetails() {
        try{
            var request = {
                companyId: this.$session.get('companyId'),
                tokenId: this.opTicketData.tokenBookingId
            };
           const response=await this.$http.post(
                    "v2/gettokendetails",
                    JSON.stringify(request), {
                        headers: {
                            "Content-Type": "application/json"
                        }
                    })
                
                    this.opTicketData.doctorId = response.data.data.doctorId;
                    this.opTicketData.appointmentDate = response.data.data.appointmentDate;
                    this.opTicketData.appointmentTime =  this.convertTo24Hour(response.data.data.appointmentTime)
                    this.opTicketData.bookingPhoneNo = response.data.data.bookedNo;
                    this.opTicketData.tokenNo = response.data.data.tokenNo;
                    this.opTicketData.doctorQualification = response.data.data.qualification;
                     if (this.opTicketData.doctorId) {
            this.doctorOnChange(this.opTicketData.doctorId);
        }
                }
                catch(error){
                   console.error("Error loading token details:", error);
                }
        },
       
      
        async getOpDetails() {
          try{
            var request = {
                companyId: this.$session.get('companyId'),
                refId: this.opTicketData.opId,
                billType: 1,
                attachedFlag: "Y"
            };
            const response=await this.$http.post(
                    "v2/getopdetails",
                    JSON.stringify(request), {
                        headers: {
                            "Content-Type": "application/json"
                        }
                    })
                Object.assign(this.opTicketData, response.data.data.opData);

                   
                    this.opTicketData.opDate=response.data.data.opData.opDate;
       
                    this.patientDetails = {
                    name: this.opTicketData.patientName || "",
                    age: this.opTicketData.patientAge || "",
                    gender: this.opTicketData.gender || "",
                    phoneNo: this.opTicketData.phoneNo || "",
                    place: this.opTicketData.place || ""
                    };


                    if( this.opTicketData.appointmentDate){
                    this.opTicketData.appointmentDate=response.data.data.opData.appointmentDate;
                    }
                   
                   if (response.data.data.billData) {
      this.BillData = {
        ...response.data.data.billData,
        billItems: response.data.data.billData.billItems.map(item => ({
          ...item,
          billItem: {
            id: item.billItemId,
            name: item.billItem
          }
        }))
      };
                    
                         if (parseFloat(this.BillData.receiptAmount) > 0) {
                            this.readonlyFlag  = true;
                             // this.saveFlag = true;
                             console.log("Readonly true because balanceAmount=0", this.readonlyFlag);
                        } else {
                            this.readonlyFlag = false;
                            this.saveFlag = false;
                             console.log("Readonly false, balanceAmount=", this.BillData.balanceAmount);
                        }
                       
                    } 
                    
                    else {
                        this.BillData = {
                            billItems: [],
                            paymentModeId: "1",
                            discountType: "V"
                        };
                        this.readonlyFlag  = false;
                          this.saveFlag = false;
                    }
                   
                    setTimeout(() => {
                        this.$refs.billing.showTotal();
                    }, 1000);
                }
                catch(error) {
                    this.readonlyFlag = this.saveFlag = this.$refs.billing.readonlyFlag = false;
                }
        },
 
        async getDoctorList() {
  try {
    var request = { companyId: this.$session.get('companyId') };
    const response = await this.$http.post("getdoctorlist", JSON.stringify(request), {
      headers: { "Content-Type": "application/json" }
    });
    response.data.data.forEach((value) => {
      this.doctorList.push(value);
    });
  } catch (error) {
    console.error("Error loading doctor list:", error);
  }
},
        getBillReference() {
            var request = {
                companyId: this.$session.get('companyId'),
                patientId: this.patientId,
                billType: this.BillData.billType
            }
            this.$http.post(
                    "v2/getbillreference",
                    JSON.stringify(request), {
                        headers: {
                            "Content-Type": "application/json"
                        }
                    })
                .then(response => {
                    this.reference = response.data.data;
                });
        },
        validateOp() {
            this.errorMessage = [];  

            if (!this.patientId) {
                this.errorMessage.push('Patient ID is required.');
            }

            if (!this.patientDetails.name || this.patientDetails.name.trim() === '') {
                this.errorMessage.push('Patient name is required.');
            }

            if (!this.patientDetails.age || this.patientDetails.age.trim() === '') {
                this.errorMessage.push('Patient age is required.');
            }

            if (!this.patientDetails.gender || this.patientDetails.gender.trim() === '') {
                this.errorMessage.push('Patient gender is required.');
            }
              if (!this.opTicketData.doctorId) {
        this.errorMessage.push('Doctor selection is required.');
    }

                if (this.errorMessage.length > 0) {
                    console.log('Validation failed with errors:', this.errorMessage);
                return;
            }
            this.opTicketData.patientName = this.patientDetails.name;
            this.opTicketData.patientAge = this.patientDetails.age;
            this.opTicketData.gender = this.patientDetails.gender;
            this.opTicketData.phoneNo = this.patientDetails.phoneNo;
            this.opTicketData.place = this.patientDetails.place;

            if (this.$refs.billing.checkBillrows()) {
                if (this.BillData.billItems.length === 0) {
                console.log("Saving OP without bill items");
                this.saveOp();
                } else {
                console.log("Saving OP with bill items");
                if (this.$refs.billing.validateBill()) {
                    this.saveOpWithBill();
                }
                }
            }
            

        },

        saveOp() {
            
            this.$validator.validate().then(valid => {
                if (valid) {
                    var request = {
                        companyId: this.$session.get('companyId'),
                        patientId: this.patientId,
                        opData: this.opTicketData,
                        userId: this.$session.get('userId'),
                    }
                    console.log("opticket data",opData)
                    this.$http.post(

                            "v2/saveop",
                            JSON.stringify(request), {
                                headers: {
                                    "Content-Type": "application/json"
                                }
                            })
                        .then(response => {
                            this.saveFlag = this.readonlyFlag = this.$refs.billing.readonlyFlag = true;
                            this.printFlag = false;
                            this.opTicketData.opId = response.data.data.opId;
                            this.BillData.refId = response.data.data.opId;

                            this.$vs.notify({
                                title: 'Saved Successfully',
                                color: 'success',
                                iconPack: 'feather',
                                icon: 'icon-check',
                                position: 'top-center'
                            });

                        });
                }
            })
        },
        saveOpWithBill() {
            
            this.$validator.validate().then(valid => {
                if (valid) {
                    var request = {
                        companyId: this.$session.get('companyId'),
                        patientId: this.patientId,
                        opData: this.opTicketData,
                        userId: this.$session.get('userId'),
                    }
                    this.$http.post(
                            "v2/saveop",
                            JSON.stringify(request), {
                                headers: {
                                    "Content-Type": "application/json"
                                }
                            })
                        .then(response => {
                            this.saveFlag = true;
                            this.printFlag = false;
                            this.opTicketData.opId = response.data.data.opId;
                            this.BillData.refId = response.data.data.opId;
                            this.readonlyFlag = true;
                            this.$refs.billing.saveBill();
                        });
                }
            })
        },

        async printBill() {
          this.showBill = true;

    this.$nextTick(() => {
      setTimeout(() => {
      window.print();
      this.showBill = false;
      },300)
    }); 
        },
    
     async printOp() {
  
  await this.getOpDetails();

 
  this.showOp = true;

  this.$nextTick(() => {
    setTimeout(() => {
      window.print();
      this.showOp = false;
    }, 200); 
  });
},
      

onAppointmentDateChange() {
  console.log("Date changed:", this.opTicketData.appointmentDate);
  this.showSchedule = false;
  this.availableTokens = [];
},

 
doctorOnChange(doctorId) {
 
 this.showSchedule = false;
  this.availableTokens = [];
  if (!doctorId) {
    // If no doctor selected, keep one empty row for manual entry
    this.BillData.billItems = [{
      slNo: 1,
      billItemId: 0,
      qty: "",
      rate: "",
      amount: "",
      taxId: 1,
      taxAmount: "",
      gstValue: ""
    }];
    this.recalculateSlNo();
    this.$refs.billing.showTotal();
    return;
  }

  const selectedDoctor = this.doctorList.find(doc => doc.id === doctorId);
  if (selectedDoctor) {
    this.opTicketData.doctorName = selectedDoctor.name;
      
  }

  const request = {
    companyId: this.$session.get('companyId'),
    doctorId: doctorId
  };

  this.$http.post("v2/getDefaultDoctorCharges", JSON.stringify(request), {
    headers: { "Content-Type": "application/json" }
  })
  .then(response => {
    const doctorCharges = response.data.data || [];

    const newBillItems = doctorCharges.map((charge, idx) => ({
      slNo: idx + 1,
      billItemId: charge.itemId,
     billItem: {
    id: charge.itemId,
    name: charge.billItem
  },
      qty: 1,
      rate: parseFloat(charge.price),
      amount: parseFloat(charge.price),
      taxId: parseInt(charge.taxId),
      taxAmount: parseFloat(charge.taxAmount),
      gstValue: 0,
    }));

    // If default charges exist → add them + one empty row at the end
    if (newBillItems.length > 0) {
      this.BillData.billItems = [
        ...newBillItems,
        {
          slNo: newBillItems.length + 1,
          billItemId: 0,
          qty: "",
          rate: "",
          amount: "",
          taxId: 1,
          taxAmount: "",
          gstValue: ""
        }
      ];
    } else {
      // If no default charges → just one empty row
      this.BillData.billItems = [{
        slNo: 1,
        billItemId: 0,
        qty: "",
        rate: "",
        amount: "",
        taxId: 1,
        taxAmount: "",
        gstValue: ""
      }];
    }

    this.recalculateSlNo();
    this.$refs.billing.showTotal();
  })
  .catch(err => {
    this.$vs.notify({
      title: "Error",
      text: "Unable to fetch doctor charges",
      color: "danger"
    });
    this.BillData.billItems = [{
      slNo: 1,
      billItemId: 0,
      qty: "",
      rate: "",
      amount: "",
      taxId: 1,
      taxAmount: "",
      gstValue: ""
    }];
    this.recalculateSlNo();
    this.$refs.billing.showTotal();
  });
},

recalculateSlNo() {
  this.BillData.billItems.forEach((item, index) => {
    item.slNo = index + 1;
  });
},
 
       
        confirmCancelOp() {
    this.$vs.dialog({
       html: true,
      type: 'confirm',
      color: 'danger',
      title: '⚠️ Confirm OP Cancellation',
      text: 'Are you sure you want to cancel this OP ticket? This action cannot be undone.',
      acceptText: 'Yes, Cancel',
      cancelText: 'No',
      accept: () => {
        this.cancelOp();
      }
    });
  },
          cancelOp() {
            var request = {
                companyId: this.$session.get('companyId'),
                refId: this.opTicketData.opId,
                refTypeId:1
            };
            this.$http.post(
                    "cancelop",
                    JSON.stringify(request), {
                        headers: {
                            "Content-Type": "application/json"
                        }
                    })
                .then(response => {

                    if(response.data.statusCode==200){
                         this.$vs.notify({
                                title: 'Cancelled',
                                color: 'success',
                                iconPack: 'feather',
                                icon: 'icon-check',
                                position: 'top-center'
                            });
                    }else{
                        this.$vs.notify({
                                title: 'This action is blocked, the receipt has been already issued',
                                color: 'danger',
                                iconPack: 'feather',
                                icon: 'icon-check',
                                position: 'top-center'
                            });
                    }
                  
                }).catch(error => {
                  
                    this.errorMessage.push("This action is blocked, the receipt has been already issued.")      
              });
        },
    }
}
</script>

<style scoped>
.footer {
  position: fixed;
  left: 0;
  bottom: -20px;
  width: 100%;
  z-index: 500;
}

.inputStyles {
  font-size: 11.8px;
  font-weight: 600;
}

.topPad {
  padding-top: 7px;
}
.responsive-opno {
  width: 100%;
  box-sizing: border-box;
}

.myselect:focus {
  border: 1px solid blue;
}
.loader-circle {
  border: 5px solid #f3f3f3;
  border-top: 5px solid rgb(25, 71, 170);
  border-radius: 50%;
  width: 40px;
  height: 40px;
  animation: spin 1s linear infinite;
  margin-top: 5px;
}

@keyframes spin {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}

.disabled-icon {
  opacity: 0.5; /* make icon look faded */
  pointer-events: none; /* disable clicking */
  cursor: not-allowed; /* change cursor */
}

.selected {
  background-color: #d0ebff; /* light blue highlight */
  font-weight: bold;
}
tr:hover {
  background-color: #f1f1f1; /* subtle hover effect */
  cursor: pointer;
}
/* Normal popup with your own class */
.con-vs-popup.holamundo .vs-popup {
  width: 800px !important;
  height: auto !important;
  max-width: 90% !important;

  max-height: 90% !important;
}
.token-table th {
  background: #d7d9db; /* light grey header */

  border-bottom: 2px solid #dee2e6;
  font-weight: bold;
}
.token-table td {
  padding: 8px 10px;
  border-bottom: 1px solid #dee2e6; /* line between rows */
}
.available {
  color: green;
}

.booked {
  color: red;

  cursor: not-allowed; /* optional: show it's unclickable */
}
</style>

